import {createAction} from '@reduxjs/toolkit'

import {FDS_BLOCK_REASON, FDSAuthLevel} from '@web/core/constants'
import {FdsOptions} from '@web/slices/fds/slice'

type FDSBlockReasonType = Constant<typeof FDS_BLOCK_REASON>

export type FDSStartParam = {
    /** uuid */
    uuid: string
    /** 인증 레벨 */
    level: FDSAuthLevel
    /** 인증 세션키. ars 는 start 시 sessionKey가 없다. */
    sessionKey: Maybe<string>
    /** 인증 타입 */
    blockReason: Maybe<FDSBlockReasonType>
    /** fds정보 검증용 hash */
    fdsCheckHash?: string
    /** 세션키 검증용 hash */
    sessionCheckHash?: string
    /** fds 옵션 */
    options?: FdsOptions
}

/** fds 진행에 필요한 fds authentication 정보를 세팅합니다 */
const startFDS = createAction<FDSStartParam>('processFds/startFDS')

export default startFDS
